( function () {
	'use strict';

	function edivateLibraryService ( apiService, logger, $q, Session ) {
		function getLibrary ( searchData, start, rows, searchType ) {
			return apiService.edivateLibrary.query( {
				'categories' : [ searchType ],
				'q'          : searchData,
				'start'      : start,
				'rows'       : rows
			} )
			.$promise
			.then( function ( resource ) {
				logger.info( 'Library successfully loaded' );

				return resource.docs.map( function ( item ) {
					return apiService.getContentDetails.query( {
						'userId'    : Session.getCredentials().userId,
						'contentId' : item.path.replace( '/v1/content/', '' )
					} );
				} );
			} );
		}

		return {
			'getLibrary' : getLibrary
		};
	}

	angular
		.module( 'app.templates' )
		.factory( 'edivateLibraryService', edivateLibraryService );
} )( );
